import React from "react";

export function Logo({ height = 44, showWordmark = false }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <img
        src="/assets/souqstream-logo.png"
        alt="SouqStream"
        style={{ height, width: "auto", objectFit: "contain" }}
        data-testid="souqstream-logo"
      />
      {showWordmark && (
        <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 22 }}>
          <span style={{ color: "var(--brand)" }}>Souq</span>
          <span style={{ color: "var(--gold)" }}>Stream</span>
        </span>
      )}
    </div>
  );
}

export function Wordmark({ size = 26 }) {
  return (
    <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: size, display: "inline-flex", alignItems: "center" }}>
      <span className="ss-dot" style={{ marginRight: 8 }} />
      <span style={{ color: "var(--brand)" }}>Souq</span>
      <span style={{ color: "var(--gold)" }}>Stream</span>
    </span>
  );
}
